import {
  EIndicadoresUserPreferences,
  IDataPreference,
  IViewContextUserPreferences
} from "@/features/financas/views/Indicadores/@types/type";

export const dialogPreferenciasCardProvider = Symbol(
  "dialogPreferenciasCardProvider"
);

export const customParams: IViewContextUserPreferences = {
  view: EIndicadoresUserPreferences.view,
  context: EIndicadoresUserPreferences.context
};

export abstract class AbstractSaveToApi<T> {
  abstract buildPreference(filtro: T): IDataPreference<unknown>[];
}

export interface IShortcutPreference {
  id: number;
  shortcutSelecionado: number;
  range: {
    start: string;
    end: string;
  };
}
